import { render, staticRenderFns } from "./inventoryDetail.vue?vue&type=template&id=6870ee4e&scoped=true&"
import script from "./inventoryDetail.vue?vue&type=script&lang=js&"
export * from "./inventoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6870ee4e",
  null
  
)

export default component.exports